import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/core-js/modules/es.array.iterator.js";
import "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/core-js/modules/es.promise.js";
import "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/core-js/modules/es.object.assign.js";
import "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import envCheck from '@vip-activity/business/envCheck';
import { checkEndTime, setPageTitle, setShare } from '@vip-activity/business/pageSetting';
import { loginService } from '@vip-activity/business';
import '@/plugins';
import '@/mixin';
import '@/mixin/level';
Vue.config.productionTip = false;
Vue.prototype.setting = window.setting;
Vue.prototype.eventBus = new Vue();

var getInitInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 拉取明星总榜和粉丝榜
            store.dispatch('getStarRanks');
            store.dispatch('getFansRanks');
            _context.prev = 2;
            _context.next = 5;
            return loginService.init();

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            console.log(_context.t0);

          case 10:
            if (loginService.isLogin) {
              // 登录情况下，拉取用户相关的信息
              store.dispatch('getMyProps');
              store.dispatch('getMyVoteInfo');
              store.dispatch('getBookCouponState');
              store.dispatch('getLookTaskState');
            }

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));

  return function getInitInfo() {
    return _ref.apply(this, arguments);
  };
}();

envCheck(function () {
  new Vue({
    store: store,
    render: function render(h) {
      return h(App);
    }
  }).$mount('#app');
  getInitInfo();
  checkEndTime();
  setPageTitle();
  setShare();
});
var _window = window,
    Aegis = _window.Aegis;

if (Aegis) {
  new Aegis({
    id: '7600'
  });
}